// extracted by mini-css-extract-plugin
module.exports = {"message-button":"_3ErqYkj-","messageButton":"_3ErqYkj-"};